module.exports = __webpack_public_path__ + "img/rating-1.980f1e39.svg";